/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link, Typography2, typography2 } from '@coursera/cds-core';
import { DegreeIcon } from '@coursera/cds-icons';

import { getHeadingStyle } from 'bundles/unified-description-page-common/components/modules/product-overview/details/Details';
import { CREDITS_ANCHOR_ID } from 'bundles/unified-description-page-common/constants';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

import _t from 'i18n!nls/xdp';

const styles = {
  itemTitle: css`
    padding: var(--cds-spacing-100) 0;
  `,
  icon: css`
    display: block;
  `,
  link: css`
    ${typography2.actionSecondary}
    text-decoration: none;
    color: var(--cds-color-interactive-primary);
    letter-spacing: var(--cds-letter-spacing-100);
    padding: 0;
    text-align: left;
    vertical-align: unset;

    :hover {
      text-decoration: underline;
    }

    :focus {
      text-decoration: underline;
      background-color: var(--cds-color-blue-25);
    }
  `,
};

const StackabilityDetailItem = () => {
  const { enableXDPRedesignPhase1, enableXDPRedesignDescriptionRework } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignDescriptionRework;

  return (
    <React.Fragment>
      <DegreeIcon size="large" css={styles.icon} />
      <Typography2 variant={getHeadingStyle(enableXDPRedesign)} css={styles.itemTitle} component="div">
        {_t('Build towards a degree')}
      </Typography2>
      <Link href={`#${CREDITS_ANCHOR_ID}`} css={styles.link} aria-label={_t('Learn more about degree credit')}>
        {_t('Learn more')}
      </Link>
    </React.Fragment>
  );
};

export default StackabilityDetailItem;
